import * as React from 'react';
import {ISolution} from "../../data/SolutionDataSource";
import {IBundle} from "../../data/BundleData";
import {SecondaryBar} from "../widgets/SecondaryBar";

import {PrimaryLayout} from "../widgets/PrimaryLayout";
import {observer} from "mobx-react";
import {action, computed, observable} from "mobx";
import {CategoryFilter} from "./CategoryFilter";

import './Library.pcss';
import {BundleCard} from "../widgets/BundleCard";

interface Props {
  solution:ISolution;
  onSelectBundle:(bundle:IBundle)=>void;
  onBack:()=>void;
}

@observer
export class Library extends React.Component<Props> {

  @observable selectedCategory = '';

  @computed get filteredBundles() {
    return this.selectedCategory ? this.props.solution.bundles.filter(b=>b.category===this.selectedCategory) : this.props.solution.bundles;
  }

  @computed get categories() {
    const categories:string[] = [];
    for(let i=0;i<this.props.solution.bundles.length;i++) {
      const cat = this.props.solution.bundles[i].category;
      if(-1===categories.indexOf(cat)) {
        categories.push(cat);
      }
    }
    return categories;
  }

  @computed get filterStatus() {
    return "Showing "+(this.selectedCategory ? "items categorized as "+this.selectedCategory : "everything")+ " from "+this.props.solution.name;
  }

  @action handleSelectCategory = (category:string) => {
    this.selectedCategory = category;
  }

  render() {
    const {solution, onBack} = this.props;
    return (
      <PrimaryLayout className={"bundle-library"}>
        <SecondaryBar title={solution.name} subTitle={solution.subTitle} buttonAction={onBack} />
        <div className={"pl-inner"}>

          <div className="filter-group" role="radiogroup" aria-controls="library-items" aria-labelledby="filter-group-label">
            <div id="filter-group-label">Filter by</div>
            <div className={'filters'}>
              <CategoryFilter
                category={""}
                label="All"
                selectedCategory={this.selectedCategory}
                onClick={this.handleSelectCategory}
              />
              {this.categories.map((cat,idx)=>
                <CategoryFilter key={idx} category={cat} selectedCategory={this.selectedCategory} onClick={this.handleSelectCategory} />
              )}
            </div>
          </div>

          <p aria-live={"polite"}>{this.filterStatus}</p>

          <ul id="library-items" className={"library-items reset"}>
            {this.filteredBundles.map(bundle=>
              <li key={bundle._id}>
                <BundleCard bundle={bundle} onClick={this.props.onSelectBundle} />
              </li>
            )}
          </ul>

        </div>
      </PrimaryLayout>
    );
  }

}

;
